(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magazine-studio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mgzReady) return;
    window.__mgzReady = true;

    /* ---------- スライダー（商品画像・ギャラリー） ---------- */
    function items(track) { return Array.prototype.slice.call(track.children); }

    function currentIndex(track) {
      var list = items(track);
      if (!list.length) return 0;
      var base = list[0].offsetLeft, best = 0, min = Infinity;
      list.forEach(function (el, i) {
        var d = Math.abs(el.offsetLeft - base - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }

    function goTo(track, i) {
      var list = items(track);
      if (!list.length) return;
      i = Math.max(0, Math.min(list.length - 1, i));
      track.scrollTo({ left: list[i].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
    }

    function syncDots(track) {
      var root = track.closest('[data-mgz-carousel]');
      if (!root) return;
      var i = currentIndex(track);
      root.querySelectorAll('[data-mgz-dot]').forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === i);
        if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }

    /* ---------- 読了プログレスバー ---------- */
    function updateProgress() {
      document.querySelectorAll('[data-mgz-progress]').forEach(function (bar) {
        var root = bar.closest('.mgz');
        if (!root) return;
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight;
        var total = r.height - vh;
        var p = total > 0 ? -r.top / total : (r.top < 0 ? 1 : 0);
        p = Math.max(0, Math.min(1, p));
        bar.firstElementChild.style.transform = 'scaleX(' + p + ')';
        bar.style.opacity = (r.top < vh * 0.3 && r.bottom > 0) ? '1' : '0';
      });
    }

    /* ---------- マーカーが引かれるアニメーション ---------- */
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -15% 0px' }) : null;

    function initAnim() {
      document.querySelectorAll('.mgz--anim em:not([data-mgz-seen])').forEach(function (em) {
        em.setAttribute('data-mgz-seen', '');
        if (io) io.observe(em); else em.classList.add('is-in');
      });
    }

    /* ---------- イベント ---------- */
    var ticking = false;
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && t.hasAttribute('data-mgz-track')) {
        clearTimeout(t.__mgzTimer);
        t.__mgzTimer = setTimeout(function () { syncDots(t); }, 60);
        return;
      }
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { ticking = false; updateProgress(); });
      }
    }, { capture: true, passive: true });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var btn = e.target.closest('[data-mgz-prev], [data-mgz-next], [data-mgz-dot]');
      if (btn) {
        var root = btn.closest('[data-mgz-carousel]');
        var track = root && root.querySelector('[data-mgz-track]');
        if (!track) return;
        e.preventDefault();
        var cur = currentIndex(track);
        if (btn.hasAttribute('data-mgz-prev')) goTo(track, cur - 1);
        else if (btn.hasAttribute('data-mgz-next')) goTo(track, cur + 1);
        else goTo(track, parseInt(btn.getAttribute('data-mgz-dot'), 10));
        return;
      }

      var link = e.target.closest('a[href^="#mgz-h-"]');
      if (link) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
      }
    });

    function init() { updateProgress(); initAnim(); }
    window.addEventListener('resize', updateProgress);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
